import { createReducer, Action, on } from '@ngrx/store';

import { DatapointLookupActions } from './datapoint-lookup.actions';
import { DatapointLookupState } from './datapoint-lookup.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { LookupEntry } from '../../features/unified-datapoint/models/datapoint-lookup-collection.model';

export const initialState: DatapointLookupState = {
  formulaReferences: {},
  formulaById: {},
  topics: {},
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      DatapointLookupActions.LoadLookup,
      (state): DatapointLookupState => ({
        ...state,
        error: undefined,
        topics: {},
        formulaReferences: {},
      })
    ),
    on(
      DatapointLookupActions.LoadLookupSuccess,
      (state, action): DatapointLookupState => ({
        ...state,
        topics: action.lookup.topics,
        formulaReferences: action.lookup.formulaReferences,
        formulaById: action.lookup.formulaById,
      })
    ),
    on(
      DatapointLookupActions.LoadFormulaLookup,
      DatapointLookupActions.LoadTopicLookup,
      (state): DatapointLookupState => ({ ...state, error: undefined })
    ),
    on(DatapointLookupActions.LoadFormulaLookupSuccess, (state, action): DatapointLookupState => {
      const formulaById = { ...state.formulaById };
      const formulaReferences = { ...state.formulaReferences };

      Object.keys(action.lookup.formulaReferences).forEach((key) => {
        formulaReferences[key] = formulaReferences[key]
          ? mergeLookups(formulaReferences[key], action.lookup.formulaReferences[key])
          : action.lookup.formulaReferences[key];
      });

      Object.keys(action.lookup.formulaById).forEach((key) => {
        formulaById[key] = action.lookup.formulaById[key];
      });

      return {
        ...state,
        formulaById,
        formulaReferences,
      };
    }),
    on(DatapointLookupActions.LoadTopicLookupSuccess, (state, action): DatapointLookupState => {
      const topics = { ...state.topics };

      Object.keys(action.lookup.topics).forEach((key) => {
        topics[key] = topics[key]
          ? mergeLookups(topics[key], action.lookup.topics[key])
          : action.lookup.topics[key];
      });

      return {
        ...state,
        topics,
      };
    }),
    on(
      DatapointLookupActions.LoadLookupFail,
      DatapointLookupActions.LoadFormulaLookupFail,
      DatapointLookupActions.LoadTopicLookupFail,
      (state, action): DatapointLookupState => ({ ...state, error: action.error })
    )
  )
);

export function reducer(state: DatapointLookupState | undefined, action: Action) {
  return featureReducer(state, action);
}

function mergeLookups<T extends LookupEntry>(lookup: T[], newLookup: T[]): T[] {
  const lookupById = new Map(lookup.map((entry) => [entry._id, entry]));

  newLookup.forEach((entry) => {
    lookupById.set(entry._id, entry);
  });

  return Array.from(lookupById.values());
}
